module.exports = require("./my.d.ts");